

import React, { useContext, useEffect, useState, useRef } from "react";
import { Link, useLocation, useSearchParams, useParams, useNavigate } from 'react-router-dom';
import http from "../Services/httpService";
import Services from "../Services/Services";
import { toast } from "react-toastify";

import horzintal3 from '../Images/horzintal3.png'
import mobile from '../Images/mobile.png'
import password from '../Images/password.png'
import barcode from '../Images/barcode.png'
import person from '../Images/person.png'
import gift from '../Images/gift.png'

import noronInfo from '../Images/noronInfo.png'
export default function Exhibition() {
    let navigate = useNavigate();
    useEffect(() => {

    }, []);
    const defaultForm = { name:"", Phone:"",Province:"",Number:"",Company:""
        ,CompanyGoverment: true
    ,Email:"",Activity:"" }
    const formRef = useRef(null);
    const [form, setForm] = useState(defaultForm)

    const [isPosting, setIsPosting] = useState(false)
    const doPost = async (e) => {
        e.preventDefault();
        const forms = formRef.current;
        if (forms.checkValidity() === false) {
            toast.error('داده های ورودی را بررسی بفرمایید', { theme: "colored" });
            forms.classList.add('was-validated')
            return;
        }
        setIsPosting(true);
        await Services.ExhibitionPost(form)
            .then(({ data }) => {
                setIsPosting(false);
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    return
                }
                toast.dark("با تشکر اطلاعات ارسالی ثبت شد")
                setForm(defaultForm)
            })
            .catch(err => {
                setIsPosting(false);
            });
    }

    useEffect(() => {
        console.log('form', form)
    }, [form]);
    return (
        <>
        {/*
            <div className="row mt-1  pt-5">
                <div className='col d-flex justify-content-center'>
                    <img src={noronInfo} />
                </div>
            </div>
            */
        }
            <form ref={formRef} className=" needs-validation">
                <div className="input-group mb-3">
                    <div className="input-group-text" >
                        <img src={person} className=" " />
                    </div>
                    <input
                        asp-for="name"
                        type="text"
                        name="name"
                        value={form.name}
                        onChange={e => http.handleChange(e, form, setForm)}
                        className="form-control"
                        placeholder="نام و نام خانوادگی"
                        required
                        autoComplete="off" />
                    <span asp-validation-for="name" className="text-danger" />
                </div>
                <div className="input-group mb-3">
                    <div className="input-group-text" >
                        <img src={mobile} className=" " />
                    </div>
                    <input
                        asp-for="Phone"
                        type="number"
                        name="Phone"
                        value={form.Phone}
                        onChange={e => http.handleChange(e, form, setForm)}
                        className="form-control"
                        placeholder="شماره موبایل"
                        required
                        autoComplete="off" />
                    <span asp-validation-for="username" className="text-danger" />
                </div>
                <div className="input-group mb-3">
                    <div className="input-group-text" >
                        <img src={person} className=" " />
                    </div>
                    <input
                        asp-for="Province"
                        type="text"
                        name="Province"
                        value={form.Province}
                        onChange={e => http.handleChange(e, form, setForm)}
                        className="form-control"
                        placeholder="استان/شهر"
                        autoComplete="off" />
                    <span asp-validation-for="password" className="text-danger" />
                </div>
                <div className="input-group mb-3">
                    <div className="input-group-text" >
                        <img src={person} className=" " />
                    </div>
                    <input
                        asp-for="Number"
                        type="text"
                        name="Number"
                        value={form.Number}
                        onChange={e => http.handleChange(e, form, setForm)}
                        className="form-control"
                        placeholder="واتس آپ/اینستا"
                        autoComplete="off" />
                    <span asp-validation-for="password" className="text-danger" />
                </div>
                <div className="input-group mb-3">
                    <div className="input-group-text" >
                        <img src={person} className=" " />
                    </div>
                    <input
                        asp-for="Company"
                        type="text"
                        name="Company"
                        value={form.Company}
                        onChange={e => http.handleChange(e, form, setForm)}
                        className="form-control"
                        placeholder="نام شرکت/سازمان/فروشگاه"
                        autoComplete="off" />
                    <span asp-validation-for="Company" className="text-danger" />
                </div>
                <div className="row mb-3">
                    <div className="col">
                        <div className="form-check  form-check-inline">
                            <input
                                className="form-check-input"
                                type="radio"
                                value={true}
                                name="CompanyGoverment"
                                onChange={e => http.handleChange(e, form, setForm)}
                                checked={form.CompanyGoverment === true}
                            />
                            <label className="form-check-label text-white" htmlFor="checkIndeterminate">
                                دولتی
                            </label>
                        </div>
                        <div className="form-check  form-check-inline">
                            <input
                                className="form-check-input"
                                type="radio"
                                value={false}
                                name="CompanyGoverment"
                                onChange={e => http.handleChange(e, form, setForm)}
                                checked={form.CompanyGoverment === false}
                            />
                            <label className="form-check-label text-white" htmlFor="checkIndeterminate">
                                خصوصی
                            </label>
                        </div>
                    </div>
                </div>

                <div className="input-group mb-3">
                    <div className="input-group-text" >
                        <img src={person} className=" " />
                    </div>
                    <input
                        asp-for="Email"
                        type="text"
                        name="Email"
                        value={form.Email}
                        onChange={e => http.handleChange(e, form, setForm)}
                        className="form-control"
                        placeholder="ایمیل"
                        autoComplete="off" />
                    <span asp-validation-for="Email" className="text-danger" />
                </div>
                <div className="input-group mb-3">
                    <div className="input-group-text" >
                        <img src={person} className=" " />
                    </div>
                    <input
                        asp-for="Activity"
                        type="text"
                        name="Activity"
                        value={form.Activity}
                        onChange={e => http.handleChange(e, form, setForm)}
                        className="form-control"
                        placeholder="حوزه فعالیت"
                        autoComplete="off" />
                    <span asp-validation-for="Activity" className="text-danger" />
                </div>
                <div className="row mb-1">
                    <div className="col text-white">
                        <span>بیشتر تمایل دارید درباره کدام محصول اطلاعات دریافت کنید؟</span>
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col">
                        <div className="form-check  form-check-inline">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                name="Item1"
                                onChange={e => http.handleChange(e, form, setForm)}
                                checked={form.Item1}
                            />
                            <label className="form-check-label text-white" htmlFor="checkIndeterminate">
                                دزدگیر و ردیاب خودرو
                            </label>
                        </div>
                        <div className="form-check  form-check-inline">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                name="Item2"
                                onChange={e => http.handleChange(e, form, setForm)}
                                checked={form.Item2}
                            />
                            <label className="form-check-label text-white" htmlFor="checkIndeterminate">
                                دستگاه پایش سوخت
                            </label>
                        </div>
                        <div className="form-check  form-check-inline">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                name="Item3"
                                onChange={e => http.handleChange(e, form, setForm)}
                                checked={form.Item3}
                            />
                            <label className="form-check-label text-white" htmlFor="checkIndeterminate">
                                برچسب هوشمند یابنده و مالک
                            </label>
                        </div>
                    </div>
                </div>

                <div className="row mb-1">
                    <div className="col text-white">
                        <span>در چه حوزه ای امکان همکاری و پشتیبانی از جانب ما وجود دارد؟</span>
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col">
                        <div className="form-check  form-check-inline">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                name="Item4"
                                onChange={e => http.handleChange(e, form, setForm)}
                                checked={form.Item4}
                            />
                            <label className="form-check-label text-white" htmlFor="checkIndeterminate">
                                درخواست نمایندگی فروش و توزیع
                            </label>
                        </div>
                        <div className="form-check  form-check-inline">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                name="Item5"
                                onChange={e => http.handleChange(e, form, setForm)}
                                checked={form.Item5}
                            />
                            <label className="form-check-label text-white" htmlFor="checkIndeterminate">
                                همکاری در پروژه های سازمانی
                            </label>
                        </div>
                        <div className="form-check  form-check-inline">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                name="Item6"
                                onChange={e => http.handleChange(e, form, setForm)}
                                checked={form.Item6}
                            />
                            <label className="form-check-label text-white" htmlFor="checkIndeterminate">
                                خرید محدود برای شخصی
                            </label>
                        </div>
                    </div>
                </div>
                <div className="row mb-1">
                    <div className="col text-white">
                        مایلید پس از نمایشگاه جهت ارائه اطلاعات تکمیلی و همکاری های احتمالی با شما در ارتباط باشیم؟
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col">
                        <div className="form-check  form-check-inline">
                            <input
                                className="form-check-input"
                                type="radio"
                                value={true}
                                name="Connection"
                                onChange={e => http.handleChange(e, form, setForm)}
                                checked={form.Connection === true}
                            />
                            <label className="form-check-label text-white" htmlFor="checkIndeterminate">
                                بله، لطفا با من تماس بگیرید
                            </label>
                        </div>
                        <div className="form-check  form-check-inline">
                            <input
                                className="form-check-input"
                                type="radio"
                                value={false}
                                name="Connection"
                                onChange={e => http.handleChange(e, form, setForm)}
                                checked={form.Connection === false}
                            />
                            <label className="form-check-label text-white" htmlFor="checkIndeterminate">
                                خیر، فعلا نیازی ندارم
                            </label>
                        </div>
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col">
                        <div className="form-check  form-check-inline">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                name="ReciveModeData"
                                onChange={e => http.handleChange(e, form, setForm)}
                                checked={form.ReciveModeData}
                            />
                            <label className="form-check-label text-white" htmlFor="checkIndeterminate">
                                ترجیح می دهم اطلاعات بیشتری از طریق پیام یا شبکه های اجتماعی دریافت کنم ( واتساپ - تلگرام- ایتا)
                            </label>
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col'>
                        <button
                            className="w-100 btn btn-lg btn1 py-3"
                            onClick={doPost}
                            disabled={isPosting}>
                            تائید
                            {isPosting &&
                                <div className="spinner-border spinner-border-sm" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>}
                        </button>
                    </div>
                </div>
            </form>


        </>

    );

}
